import { useClientFromUrl } from '../hooks/useClientFromUrl'
import ActivitySuggestionList from './ActivitySuggestionList'

const ErrorBoundarySuggestions: React.FC = () => {
  const { client, loading } = useClientFromUrl()

  if (loading || !client) return null

  return <ActivitySuggestionList client={client} darkBackground />
}

export default ErrorBoundarySuggestions
